import {KTIcon} from '../../../../_metronic/helpers'

const MessageModalHeader = ({setShowMessageModal, messageType}) => {
  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>{messageType === 'ban' ? 'Ban User' : `New ${messageType} to user`}</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
          setShowMessageModal(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>

    </div>
  )
}

export {MessageModalHeader}
